import React from 'react'

import TableCategoryAccordion from './TableCategoryAccordion/index.web'
import TableHeader from './TableHeader/index.web'
import type { Props } from './types'

const TableAuto = (props: Props) => (
  <div>
    <TableHeader headerItems={props.data.header} />
    {props.data.categoryRows.map((categoryRow, categoryRowIndex, categoryRows) => (
      <TableCategoryAccordion
        key={categoryRow.key}
        categoryRow={categoryRow}
        isLast={categoryRowIndex === categoryRows.length - 1}
        onItemToggle={props.onItemToggle}
      />
    ))}
  </div>
)

export default TableAuto
